// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 2251463725
import { createAction } from 'typesafe-actions';

import type { ScrollOffset } from 'state/scroll/reducer';

export const setOffsetForKey = createAction('SCROLL/SET_OFFSET_FOR_KEY')<{
  key: string;
  offset: ScrollOffset;
}>();
